// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__VPaj3","empty":"ModalGraph_empty__3ds2O"};